import Headroom from 'headroom.js';

export default function() {
  var header = document.querySelector('body');
  if (header) {
    new Headroom(header, {
      offset: 50,
      tolerance: {
        up: 40,
        down: 10
      },
      classes: {
        initial: 'headroom', // when element is initialised
        pinned: 'headroom-pinned', // when scrolling up
        unpinned: 'headroom-unpinned', // when scrolling down
        top: 'headroom-top', // when above offset
        notTop: 'headroom-not-top' // when below offset
      }
    }).init();
  }

  let setLocaleSwitchCookie = function (chosenLanguageCode, redirectURL) {
    let formData = new FormData();
    formData.append('chosenLanguageCode', chosenLanguageCode);
    formData.append('hideLocaleSwitch', true);
    fetch('/setChosenLanguageCode',
      {
        body: formData,
        method: 'post'
      }).then(() => {
      if (document.location.href.replace(/\/$/, '') !== redirectURL.replace(/\/$/, '')) {
        let queryParam = '';
        if (new URL(document.location.href).host !== new URL(redirectURL).host) {
          queryParam = `?rememberChosenLanguage=${chosenLanguageCode}`;
        }
        if (redirectURL !== 'none') {
          document.location = redirectURL.replace(/\/$/, '') + queryParam;
        }
      }
    });
  };

  if (document.querySelector('body').classList.contains('page-header-locale-switch')) {
    document.querySelectorAll('.locale-switch .locale-switch-selector-entry a').forEach(
      (el) => el.addEventListener('click', (ev) => {
        document.querySelector('.locale-switch .locale-switch-selector-active .locale-switch-selector-country').textContent = ev.target.text.trim();
        document.querySelector('.locale-switch .btn-call2action').dataset.languageCode = ev.target.dataset.languageCode;
        document.querySelector('.locale-switch .btn-call2action').setAttribute('href', ev.target.getAttribute('href'));
        ev.preventDefault();
      })
    );
    $('.locale-switch .btn-call2action, .locale-switch .locale-switch-close').click(function () {
      let chosenLanguageCode = $(this).data('language-code');
      document.querySelector('.locale-switch').classList.add('locale-switch-hidden');
      document.querySelector('body').classList.remove('page-header-locale-switch');
      setLocaleSwitchCookie(chosenLanguageCode, $(this).attr('href'));
      return false;
    });
  }

  if ($('.country-selector-entry').length > 0) {
    $('.country-selector-entry a').click(function () {
      let chosenLanguageCode = $(this).attr('hreflang');
      setLocaleSwitchCookie(chosenLanguageCode, $(this).attr('href'));
      return false;
    });
  }
}
